import { Text, View } from "react-native";
import { AffichagePeriode } from "../../components/AffichagePeriode/AffichagePeriode";
import { DemandeAbsenceType } from "../../api/DemandeAbsence/types";

export default function ElementKanbanDemande({demande, styles} : {demande: DemandeAbsenceType, styles: any}){
    return(
        <View style={styles.dateContainer}>
            <AffichagePeriode dateDebut={demande.dateDebut} dateFin={demande.dateFin} style={styles.demandeDate} />
            <Text style={styles.demandeDuree}>{demande.duree?.texte}</Text>
        </View>
    )
}
